import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AccountRoutingModule } from './account-routing.module';
import { LoginComponent } from './login/login.component';

import { QuillModule } from 'ngx-quill';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { NamedloginComponent } from './namedlogin/namedlogin.component';


@NgModule({
  declarations: [
    LoginComponent,
    NamedloginComponent
  ],
  imports: [
    CommonModule,
    AccountRoutingModule,
    QuillModule,
    ReactiveFormsModule,
    SharedModule
  ]
})
export class AccountModule { }
